export const PATH_CORP_FAQ = `/faq/`;
export const PATH_FAQ_WITH_ID = (id: string) =>
  `${PATH_CORP_FAQ}?external_id=${id}`;
export const PATH_PRIVACY = "https://www.capitalone.com/privacy";
export const PATH_CORP_ACKNOWLEDGEMENT = `/acknowledgement/`;
